var NATIVE_BIND = require('../internals/function-bind-native');

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-avatar/~/core-js/internals/function-call.js
// module id = 170
// module chunks = 0